import type ReportDTO from "../models/finance/Reports";
import type { GenericReport } from "../models/finance/Reports";
import { FinanceType, FinanceTypeDef } from "../models/finance/FinanceType";

/**
 * Parse a report DTO into a generic report structure based on finance type
 * @param report - The report DTO from the API
 * @param type - The finance type (expense or income)
 * @returns Parsed generic report
 */
export function parseReport(report: ReportDTO, type: FinanceTypeDef): GenericReport {
  if (type === FinanceType.EXPENSE) {
    return {
      type: type,
      valuePerCategory: report.reportInfo.expensesValuePerCategory,
      valuePerDay: report.reportInfo.expensesValuePerDay,
      totalAmount: report.reportInfo.totalValues.expensesTotalAmount,
    };
  } else if (type === FinanceType.INCOME) {
    return {
      type: type,
      valuePerCategory: report.reportInfo.incomesValuePerCategory,
      valuePerDay: report.reportInfo.incomesValuePerDay,
      totalAmount: report.reportInfo.totalValues.incomesTotalAmount,
    };
  } else {
    throw new Error(`Cannot parse report for unknown type: ${type}`);
  }
}

